import { BookingPricingModelType } from 'parkdepot-shared/gql/graphql'
import { LotPricing, USER_DATA } from '../types/userData.interface'
import memoize from './memoize.utils'

export const defaultPublicPricingLot = (lotId: string): LotPricing => ({
    lot_id: lotId,
    pricing_type: BookingPricingModelType.Public
})

const getLotPricing = (user: USER_DATA, lotId?: string) => {
    if (!user?.private_pricing_lots || !lotId)
        return {
            pricing_type: BookingPricingModelType.Public,
            lot_id: lotId
        } as LotPricing

    return (
        user?.private_pricing_lots?.filter((l: LotPricing) => l.lot_id.toLowerCase() === lotId?.toLowerCase())[0] ||
        defaultPublicPricingLot(lotId)
    )
}

export const getLotPricingMemoized = memoize(getLotPricing)
